module.exports = __webpack_public_path__ + "static/img/03_08_spring.e3d860f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/03_08_spring.png
// module id = D0Jm
// module chunks = 12